import React from 'react';
import PropTypes from 'prop-types';
import utils from 'helpers/utils';
import { connect } from 'react-redux';

export default function (initialProps) {
    const {
        action,
        resource,
    } = initialProps;

    function buildError(prop) {
        return `fetchResourceById - ${ prop } is not defined`;
    }

    if (!action || !resource) {
        throw new Error(buildError('action'));
    }

    return function (WrappedComponent) {
        class FetchResourceById extends React.Component {
            constructor(props) {
                super(props);

                this.state = this.initialStateValues();
            }

            initialStateValues = () => {
                const {
                    data,
                } = this.props;

                if (!utils.isEmpty(data)) {
                    return {
                        fetchFailed: false,
                        loading: false,
                    };
                }

                return {
                    fetchFailed: true,
                    loading: true,
                };
            }

            /**
             * When the data object is empty, we will trigger the fetch.
             */
            componentDidMount() {
                const {
                    data,
                } = this.props;

                if (utils.isEmpty(data)) {
                    this.fetchData();
                }
            }

            /**
             * When the user switches on the same page, but with a different ID; this will kick in.
             *
             * @param {*} prevProps
             */
            componentDidUpdate(prevProps) {
                const {
                    id,
                } = this.props;

                if (id !== prevProps.id) {
                    this.fetchData();
                }
            }

            /**
             * Dispatching the fetch call.
             */
            fetchData = () => {
                const {
                    dispatchFetch,
                    id,
                } = this.props;

                this.setState({
                    fetchFailed: false,
                    loading: true,
                }, () => {
                    dispatchFetch({
                        onError: () => {
                            return this.setState({
                                fetchFailed: true,
                                loading: false,
                            });
                        },
                        onSuccess: () => {
                            return this.setState({
                                fetchFailed: false,
                                loading: false,
                            });
                        },
                        id: id,
                    });
                });
            }

            render() {
                const {
                    fetchFailed,
                    loading,
                } = this.state;

                return <WrappedComponent
                    { ...this.props }
                    resourceRefetch={ () => {
                        this.fetchData();
                    } }
                    resourceFetchFailed={ fetchFailed }
                    resourceFetchLoading={ loading }
                />;
            }
        }

        const mapStateToProps = (state, props) => {
            const {
                id,
            } = props;

            return {
                data: state[resource].data[id] || null,
            };
        };

        const mapDispatchToProps = (dispatch) => {
            return {
                dispatchFetch: (values) => {
                    dispatch(action(values));
                },
            };
        };

        FetchResourceById.propTypes = {
            data: PropTypes.object,
            dispatchFetch: PropTypes.func.isRequired,
            id: PropTypes.oneOfType([
                PropTypes.number,
                PropTypes.string,
            ]),
        };

        return connect(
            mapStateToProps,
            mapDispatchToProps,
        )(FetchResourceById);
    };
}



// WEBPACK FOOTER //
// ./src/components/hoc/fetchResourceById.js